export default {
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_CURRENT_PRODUCT: 'SET_CURRENT_PRODUCT',
  SET_SIMILAR_PRODUCT: 'SET_SIMILAR_PRODUCT',
  SET_LOADING: 'SET_LOADING',
};
